import { useActiveSelectedSubaccount } from './useSelectedSubaccount';
import { useSubaccountBalance } from './useSubaccountBalance';

export const useAccountMargin = () => {
  const selectedSubaccount = useActiveSelectedSubaccount();
  const {
    data: subaccountBalances,
    isPending,
    error,
  } = useSubaccountBalance(selectedSubaccount?.id);

  const data = subaccountBalances?.reduce(
    (acc, balance) => ({
      totalUsed: acc.totalUsed + balance.totalUsed,
      totalAvailable: acc.totalAvailable + balance.available,
      totalBalance: acc.totalBalance + balance.amount,
    }),
    { totalUsed: 0n, totalAvailable: 0n, totalBalance: 0n }
  );
  return {
    isPending,
    error,
    data,
  };
};
